import { Button } from './index';
export * from './Button';
export * from './props';
export default Button;